import { render, staticRenderFns } from "./Periods.vue?vue&type=template&id=d4b19774&scoped=true&"
import script from "@/views/Periods/Periods.ts?vue&type=script&lang=ts&"
export * from "@/views/Periods/Periods.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Periods/periods.scss?vue&type=style&index=0&id=d4b19774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b19774",
  null
  
)

export default component.exports